import React, { useState } from "react";
import DataTable from "./Table";
import { Form, Button } from "react-bootstrap";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function AppointmentManager(props) {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    // Sets the filtered data to the data from firebase
    setFilteredData(props.data);
  }, [props.data]);

  const filterData = (search) => {
    const searchTerm = search.target.value.toLowerCase();
    const filtered = props.data.filter(
      (item) =>
        searchCheck(item.title, searchTerm) ||
        searchCheck(item.course, searchTerm) ||
        searchCheck(item.instructor, searchTerm) ||
        searchCheck(item.proctor, searchTerm),
    );
    setFilteredData(filtered);
  };

  // Checks if the value is a string and if it includes the search term
  const searchCheck = (value, searchTerm) => {
    if (typeof value === "string" && value !== null && value !== undefined) {
      return value.toLowerCase().includes(searchTerm);
    }
    return false;
  };
  const confirmTeacher = () => {
    console.log(filteredData);
  };

  if (props.title === "Teachers Pending Approval") {
    return (
      <div className="container" {...props}>
        <h2>{props.title}</h2>
        <div className="d-flex justify-content-between align-items-center mb-3">
          
          <Form.Control
            type="text"
            placeholder="Search Teachers"
            onChange={(search) => filterData(search)}
            //add margin to bottom of search bar
            style={{ width: "300px" , margin: "10px"}}
          />
          <div style={{ width: "120px" }}></div>
        </div>

        {!filteredData.length && <p>No Teachers Pending Approval</p>}
        {filteredData.length && (
          <div className="mx-auto" style={{ maxWidth: "100%" }}>
            {filteredData.length > 0 && <DataTable data={filteredData} showCheckboxes={true} hiddenColumns={["id"]}/>}
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className="container">
        {/* Title and Search Bar */}
        <h2>{props.title}</h2>
        <div className="d-flex justify-content-between align-items-center mb-3">
          
          <Form.Control
            type="text"
            placeholder="Search Appointments"
            onChange={(search) => filterData(search)}
            //add margin to bottom of search bar
            style={{ width: "200px" }}
          />
          <div style={{ width: "120px" }}></div>
        </div>
        {/* Output Appointment data here */}
        {!filteredData.length && <p>No appointments found</p>}
        {filteredData.length > 0 && (
          <div className="mx-auto" style={{ maxWidth: "100%" }}>
            {filteredData.length > 0 && <DataTable data={filteredData} showCheckboxes={false} hiddenColumns={["id"]}/>}
          </div>
        )}
      </div>
    );
  }
}
export default AppointmentManager;
